<div class="hero">
  <div class="hero-overlay">
  </div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          <span class="fw-light">identi professionals</span><br>
        </h1>
        <h5>
          <span class="fw-light">Connecting breeders with unmatched support and exclusive benefits.</span>
        </h5>
      </div>
    </div>
  </div>
</div>
<div class="svg-container mt-4">
  <div class="svg-container-content">
    <div class="svg-container-content__img">
      <img src="/assets/images/identiprofessionals/Registration.png" class="banner-image" alt="petplan-features"/>
    </div>
    <div class="svg-container-content__title">
      Register litters
    </div>
  </div>
  <div class="svg-container-content">
    <div class="svg-container-content__img">
      <img src="/assets/images/identiprofessionals/Earn-Rewards.png" class="banner-image" alt="petplan-features"/>
    </div>
    <div class="svg-container-content__title">
      Earn Rewards
    </div>
  </div>
  <div class="svg-container-content">
    <div class="svg-container-content__img">
      <img src="/assets/images/identiprofessionals/Digital-Litter-Management.png" class="banner-image" alt="petplan-features"/>
    </div>
    <div class="svg-container-content__title">
      Digital litter management
    </div>
  </div>
  <div class="svg-container-content">
    <div class="svg-container-content__img">
      <img src="/assets/images/identiprofessionals/Transfer-of-Keepership-Icon.png" class="banner-image" alt="petplan-features"/>
    </div>
    <div class="svg-container-content__title">
      Transfer of Keepership
    </div>
  </div>
</div>
<div class="text-banner">
  <div class="text-banner-content">
    <h4>
      At identi professionals, we support breeders with exclusive benefits and streamlined services.
    </h4>
    <br>
    <h4>Join our community to access our professional account, manage litters and earn rewards.</h4>
  </div>
</div>
<div class="main-body-one">
  <div class="text-center">
    <h2>
      How It Works
    </h2>
  </div>
  <div class="d-flex justify-content-center main-body-one-content">
    <div class="main-body-one-list-container mt-4">
      <div class="main-body-one-list-container-content">
        <div class="main-body-one-list-container-content__img">
          <img src="/assets/images/identiprofessionals/idc-1234-s1.svg" class="img-with-number" alt="indenti-professionals-1"/>
        </div>
        <div class="main-body-one-list-container-content__text">
          <div class="main-body-one-list-container-content__title">Sign up:</div>
          <div class="main-body-one-list-container-content__description">Fill out our simple registration form to become a member.</div>
        </div>
      </div>
      
      <div class="main-body-one-list-container-content">
        <div class="main-body-one-list-container-content__img">
          <img src="/assets/images/identiprofessionals/idc-1234-s2.svg" class="img-with-number" alt="indenti-professionals-2"/>
        </div>
        <div class="main-body-one-list-container-content__text">
          <div class="main-body-one-list-container-content__title">Receive Access:</div>
          <div class="main-body-one-list-container-content__description">Once open, your account will be the hub for all things microchip management.</div>
        </div>
      </div>
    
      <div class="main-body-one-list-container-content">
        <div class="main-body-one-list-container-content__img">
          <img src="/assets/images/identiprofessionals/idc-1234-s3.svg" class="img-with-number" alt="indenti-professionals-3"/>
        </div>
        <div class="main-body-one-list-container-content__text">
          <div class="main-body-one-list-container-content__title">Litter Management:</div>
          <div class="main-body-one-list-container-content__description">Easily transfer your puppies and kittens to their new keepers and manage your breeding history.</div>
        </div>
      </div>
    
      <div class="main-body-one-list-container-content">
        <div class="main-body-one-list-container-content__img">
          <img src="/assets/images/identiprofessionals/idc-1234-s4.svg" class="img-with-number" alt="indenti-professionals-4"/>
        </div>
        <div class="main-body-one-list-container-content__text">
          <div class="main-body-one-list-container-content__title">Earn Rewards:</div>
          <div class="main-body-one-list-container-content__description">With every complete transfer of keepership, you can earn rewards with identi professionals.</div>
        </div>
      </div>
    </div>
    <div class="mt-3 ms-2 text-center line"></div>
    <div class="main-body-one-img-container">
      <img src="/assets/images/identiprofessionals/How-it-Works.png" class="main-body-one-img-container-content" alt="How-it-Works"/>
    </div>
  </div>
  <div class="d-flex justify-content-center mt-3">
    <button
    type="button"
    class="btn btn-brand-orange main-body-one-button"
    (click)="handleJoinNowButtonClick()"
  >
    Join now
  </button>
  <button
  (click)="handleLoginButtonClick()"
  type="button"
  class="btn blue-button ms-4 me-3 main-body-one-button"
>
  Log in
</button>
  </div>
</div>
<div class="mt-5">
  <div class="text-center">
    <h2>
      Your Next Step
    </h2>
  </div>
  <div class="d-flex justify-content-center">
    <div class="horizontal-line"></div>
  </div>
</div>
<div class="d-flex justify-content-center">
  <img src="/assets/images/identiprofessionals/next-steps.png" class="bottom-image" alt="next-steps"/>
</div>
<div class="mt-5">
  <div class="text-center">
    <h2>
      FAQS
    </h2>
  </div>
  <div class="d-flex justify-content-center">
    <div class="horizontal-line"></div>
  </div>
</div>
<div class="d-flex justify-content-center mb-5">
  <div ngbAccordion [closeOthers]="true" class="accordion-container">
    <div class="horizontal-line"></div>
    <div ngbAccordionItem class="accordion-container-item" #item1="ngbAccordionItem">
      <div ngbAccordionHeader class="d-flex align-items-center" ngbAccordionToggle>
        <h6 class="mb-0 flex-grow-1 accordion-container-item-title">What is the identi professionals programme?</h6>
        <button
          class="btn btn-link p-0"
          style="text-decoration: none;"
          ngbAccordionToggle
        >
          <fa-icon
            *ngIf="!item1.collapsed"
            [icon]="['fas', 'minus']"
            class="me-2 collapse-icon"
            ngbAccordionToggle
          ></fa-icon>
          <fa-icon
          *ngIf="item1.collapsed"
            [icon]="['fas', 'plus']"
            class="me-2 collapse-icon"
            ngbAccordionToggle
          ></fa-icon>
        </button>
      </div>
      <div ngbAccordionCollapse class="accordion-container-collapse">
        <div ngbAccordionBody class="accordion-container-item-text">
          identi professionals is the new service whereby breeders transfer puppies and
          kittens to the new keepers. This, digital-first process ensures litters are managed on
          your breeder account and are transferred to their new keepers securely.
          New keepers will be required to verify their pet and personal information and
          complete a transfer of keepership. This transfer of keepership to the new keeper will
          cost £36.
        </div>
      </div>
    </div>
    <div class="horizontal-line"></div>
    <div ngbAccordionItem class="accordion-container-item" #item2="ngbAccordionItem">
      <div ngbAccordionHeader class="d-flex align-items-center" ngbAccordionToggle>
        <h6 class="mb-0 flex-grow-1 accordion-container-item-title">Why is identi implementing this change?</h6>
        <button
          class="btn btn-link p-0"
          ngbAccordionToggle
          style="text-decoration: none;"
        >
        <fa-icon
        *ngIf="!item2.collapsed"
        [icon]="['fas', 'minus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
      <fa-icon
      *ngIf="item2.collapsed"
        [icon]="['fas', 'plus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
        </button>
      </div>
      <div ngbAccordionCollapse class="accordion-container-collapse">
        <div ngbAccordionBody class="accordion-container-item-text">
          A significant number of pets are microchipped, but their chips often go unregistered
          or are not updated with accurate information throughout their lives. This is a critical
          pet welfare issue that Identi is passionate about resolving.
          As a result, identi has introduced the new identi professionals service to tackle this
          issue at source. By not only encouraging the microchipping, but also the registration
          and correct management of microchip details, identi hopes to change the culture of
          microchipping and position it in its rightful place as an essential aspect of pet care.
          Microchip registration, transfers and detail management is essential for pet welfare.
          Without such management, pets are at great risk of going missing or getting stolen.
          Our identialert helps to dramatically reduce this risk, with over 9,000 pets reunited
          with their keepers per year*. Our service aims to reduce these risks, promote pet
          welfare and give pets the best start in life.
          Additionally, through our professionals reward scheme, identi hopes to reward
          responsible breeder behaviour.
        </div>
      </div>
    </div>
    <div class="horizontal-line"></div>
    <div ngbAccordionItem class="accordion-container-item" #item3="ngbAccordionItem">
      <div ngbAccordionHeader class="d-flex align-items-center" ngbAccordionToggle>
        <h6 class="mb-0 flex-grow-1 accordion-container-item-title">How does the programme work?</h6>
        <button
          class="btn btn-link p-0"
          ngbAccordionToggle
          style="text-decoration: none;"
        >
        <fa-icon
        *ngIf="!item3.collapsed"
        [icon]="['fas', 'minus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
      <fa-icon
      *ngIf="item3.collapsed"
        [icon]="['fas', 'plus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
        </button>
      </div>
      <div ngbAccordionCollapse class="accordion-container-collapse">
        <div ngbAccordionBody class="accordion-container-item-text">
          As a breeder, you will register the litter's microchips under your name as standard practice once they have been chipped.
          Once the new puppy or kitten is rehomed to its new keepers, you will instigate a transfer of keepership as usual. You will log into your breeder account and select 'transfer' and select which animals you are transferring.
          You will begin the process as normal by inputting the details of the new keepers. Following this, the new keepers will get a communication via email to complete and verify their information.
          After completing the information, the new keeper will be directed to make a payment of the transfer of keepership fee, which is £36, via card payment.
          After the payment is made, the transfer is complete and as a breeder you will receive a confirmation email.
          The confirmation email confirms the successful transfer of the pet. For every completed transfer of keepership that originates from your breeder account, you will earn £10 in Amazon vouchers.
        </div>
      </div>
    </div>
    <div class="horizontal-line"></div>
    <div ngbAccordionItem class="accordion-container-item" #item4="ngbAccordionItem">
      <div ngbAccordionHeader class="d-flex align-items-center" ngbAccordionToggle>
        <h6 class="mb-0 flex-grow-1 accordion-container-item-title">More details about the transfer fee.</h6>
        <button
          class="btn btn-link p-0"
          ngbAccordionToggle
          style="text-decoration: none;"
        >
        <fa-icon
        *ngIf="!item4.collapsed"
        [icon]="['fas', 'minus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
      <fa-icon
      *ngIf="item4.collapsed"
        [icon]="['fas', 'plus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
        </button>
      </div>
      <div ngbAccordionCollapse class="accordion-container-collapse">
        <div ngbAccordionBody class="accordion-container-item-text">
          The new keeper is responsible for paying a £36 fee, online, to complete the transfer of keepership and move the new pet into their name. £36 is the mandatory fee for this process. £36 gives the new keeper a completed transfer of keepership, an official keepership certificate and a year's access to identi's leading pet protection plan identialert.
          Identialert will renew every 12 months until cancelled by the keeper. The keeper will receive communications via email and will be able to see their plan on their online identibase account.
        </div>
      </div>
    </div>
    <div class="horizontal-line"></div>
    <div ngbAccordionItem class="accordion-container-item" #item5="ngbAccordionItem">
      <div ngbAccordionHeader class="d-flex align-items-center" ngbAccordionToggle>
        <h6 class="mb-0 flex-grow-1 accordion-container-item-title">My new keepers do not want to pay to transfer keepership, what can I do?</h6>
        <button
          class="btn btn-link p-0"
          ngbAccordionToggle
          style="text-decoration: none;"
        >
        <fa-icon
        *ngIf="!item5.collapsed"
        [icon]="['fas', 'minus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
      <fa-icon
      *ngIf="item5.collapsed"
        [icon]="['fas', 'plus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
        </button>
      </div>
      <div ngbAccordionCollapse class="accordion-container-collapse">
        <div ngbAccordionBody class="accordion-container-item-text">
          £36 is the payable amount to complete the essential transfer of keepership for the new keepers. Not only does this fee include the transfer,
          secure data storage and give an official keepership certificate (which is required to prove keepership of the animal), the £36 also gives the
          new keeper unlimited changes to their microchip account and access to premium features of identialert, our best selling pet protection plan for 12 months.
          Identi's belief is that every pet deserves and needs pet protection and a microchip on its own is not enough. Because of this, the identi professionals
          programme is designed to give all puppies and kittens protection from loss, theft and straying, and pet keepers full access to their pet's microchips
          as well as complete peace of mind for their pet's safety.
        </div>
      </div>
    </div>
    <div class="horizontal-line"></div>
    <div ngbAccordionItem class="accordion-container-item" #item6="ngbAccordionItem">
      <div ngbAccordionHeader class="d-flex align-items-center" ngbAccordionToggle>
        <h6 class="mb-0 flex-grow-1 accordion-container-item-title">The new keeper already has an identialert plan for other pets in their household, does this service apply to them?</h6>
        <button
          class="btn btn-link p-0"
          ngbAccordionToggle
          style="text-decoration: none;"
        >
        <fa-icon
        *ngIf="!item6.collapsed"
        [icon]="['fas', 'minus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
      <fa-icon
      *ngIf="item6.collapsed"
        [icon]="['fas', 'plus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
        </button>
      </div>
      <div ngbAccordionCollapse class="accordion-container-collapse">
        <div ngbAccordionBody class="accordion-container-item-text">
          No. If a new keeper already has other pets in their household with an active identialert plan then the transfer of keepership for a new pet is already covered free of charge with their existing plan. One of the benefits of identialert is that a single plan covers all pets within a household.
          If the new keeper already has identialert for the pets within their household and therefore has a free transfer of keepership, no payment is required for the new pet(s). A breeder will still get the £10 reward for the successful completion of these transfers.
        </div>
      </div>
    </div>
    <div class="horizontal-line"></div>
    <div ngbAccordionItem class="accordion-container-item" #item7="ngbAccordionItem">
      <div ngbAccordionHeader class="d-flex align-items-center" ngbAccordionToggle>
        <h6 class="mb-0 flex-grow-1 accordion-container-item-title">I am not a breeder but I am an implanter, is this service for me?</h6>
        <button
          class="btn btn-link p-0"
          ngbAccordionToggle
          style="text-decoration: none;"
        >
        <fa-icon
        *ngIf="!item7.collapsed"
        [icon]="['fas', 'minus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
      <fa-icon
      *ngIf="item7.collapsed"
        [icon]="['fas', 'plus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
      ></fa-icon>
        </button>
      </div>
      <div ngbAccordionCollapse class="accordion-container-collapse">
        <div ngbAccordionBody class="accordion-container-item-text">
          This service is currently available for breeders only as the pet has to be originally registered with their breeder in order to start the transfer process upon which the service is built.
        </div>
      </div>
    </div>
    <div class="horizontal-line"></div>
    <div ngbAccordionItem class="accordion-container-item" #item8="ngbAccordionItem">
      <div ngbAccordionHeader class="d-flex align-items-center" ngbAccordionToggle>
        <h6 class="mb-0 flex-grow-1 accordion-container-item-title">The owner has a plan with another database already – can we transfer them directly to identibase?</h6>
        <button
          class="btn btn-link p-0"
          ngbAccordionToggle
          style="text-decoration: none;"
        >
        <fa-icon
        *ngIf="!item8.collapsed"
        [icon]="['fas', 'minus']"
        class="me-2 collapse-icon"
        ngbAccordionToggle
        ></fa-icon>
        <fa-icon
        *ngIf="item8.collapsed"
          [icon]="['fas', 'plus']"
          class="me-2 collapse-icon"
          ngbAccordionToggle
        ></fa-icon>
        </button>
      </div>
      <div ngbAccordionCollapse class="accordion-container-collapse">
        <div ngbAccordionBody class="accordion-container-item-text">
          Yes we are able to transfer them to identibase. This should be done by calling or emailing our contact centre on 0330 9128077 who will be able to transfer database as well as keepership for the keeper.
        </div>
      </div>
    </div>
    <div class="horizontal-line"></div>
  </div>
</div>
